var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 34,
    viewBox: "0 0 149 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_919)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_168_919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 19,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3H19V31H0V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_168_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5783 3.00876C18.4298 3.00876 18.2864 3.06822 18.1823 3.17665L15.1402 6.28621L13.8889 7.61363C13.7575 7.75179 13.6841 7.93718 13.6841 8.12956V30.5523C13.6841 30.7989 13.8804 31 14.1211 31C14.2355 31 14.3447 30.9545 14.4267 30.8741L18.6176 26.696C18.86 26.4546 18.9966 26.1241 19 25.7778V3.43199C18.9966 3.19764 18.8105 3.00876 18.5817 3.00876H18.5783Z",
    fill: "url(#paint0_linear_168_919)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3159 23.2296V25.769C5.3159 26.1171 5.17763 26.4529 4.93351 26.696L0.742588 30.8723C0.660647 30.9545 0.551393 31 0.437017 31C0.196316 31 0 30.7989 0 30.5523V8.12956C0 7.93718 0.0734052 7.75179 0.203145 7.61363L1.45615 6.28621L4.4965 3.17665C4.60234 3.06822 4.74573 3.00876 4.89425 3.00876H4.89766C5.12812 3.00876 5.3159 3.19939 5.3159 3.43549V23.2296Z",
    fill: "#954AFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20571 3.00876C6.97526 3.00876 6.78748 3.19939 6.78748 3.43549V23.2296V25.769C6.78748 26.1171 6.92575 26.4529 7.16987 26.696L11.3608 30.8741C11.4427 30.9545 11.552 31 11.6664 31C11.9071 31 12.1034 30.7989 12.1034 30.5523V8.12956C12.1034 7.93718 12.03 7.75179 11.8985 7.61363L10.6472 6.28621L7.60518 3.17665C7.50104 3.06822 7.35765 3.00876 7.20913 3.00876H7.20571Z",
    fill: "url(#paint1_linear_168_919)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_168_919)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_168_919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 6,
    width: 118,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6.8483H149V33.1517H31V6.8483Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_168_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1531 6.82391V18.6726L35.5422 6.82391H31V25.9426H35.5422V14.1548L43.1531 25.9426H47.7075V6.82391H43.1531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5312 6.82394V25.9426H56.0856V18.2099H61.7725V14.581H56.0856V10.5624H63.6844V6.82394H51.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7546 15.2386C65.7546 20.8159 73.8404 19.0502 73.8404 21.4979C73.8404 22.1798 73.2194 22.7278 72.0503 22.7278C70.8082 22.7278 69.8706 22.0215 69.7731 20.9621H65.2675C65.4867 23.8968 68.1413 26.1619 72.1112 26.1619C75.8254 26.1619 78.1147 24.1647 78.1147 21.5344C78.0417 15.8719 70.0045 17.5767 70.0045 15.1534C70.0045 14.4227 70.589 13.9844 71.6606 13.9844C72.9271 13.9844 73.7065 14.6663 73.8404 15.7014H78.0417C77.7494 12.7057 75.6183 10.5259 71.7946 10.5259C67.91 10.5259 65.7546 12.657 65.7546 15.2386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4285 6.82394V10.5624H85.3847V25.9426H89.9269V10.5624H94.871V6.82394H80.4285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.334 10.5259C105.538 10.5259 107.109 11.561 107.913 12.9006V10.7451H112.455V25.9427H107.913V23.7872C107.085 25.1268 105.514 26.1619 103.31 26.1619C99.6933 26.1619 96.795 23.1053 96.795 18.3195C96.795 13.5216 99.6933 10.5259 103.334 10.5259ZM104.662 22.0946C106.391 22.0946 107.913 20.7672 107.913 18.3439C107.913 15.9206 106.391 14.581 104.662 14.581C102.957 14.581 101.422 15.8962 101.422 18.3195C101.422 20.7429 102.957 22.0946 104.662 22.0946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.985 10.7451L122.575 20.2436L119.141 10.7451H114.063L120.103 25.419L116.705 33.1517H121.588L130.904 10.7451H125.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.236 26.1253C129.236 26.5515 129.565 26.8925 130.064 26.8925C130.551 26.8925 130.892 26.5515 130.892 26.1253C130.892 25.6869 130.551 25.3459 130.064 25.3459C129.565 25.3459 129.236 25.6869 129.236 26.1253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27 24.5057C131.27 25.9792 132.207 26.8925 133.547 26.8925C134.679 26.8925 135.483 26.2105 135.726 25.1389H134.241C134.119 25.4799 133.9 25.6747 133.522 25.6747C133.023 25.6747 132.682 25.2729 132.682 24.5057C132.682 23.7263 133.023 23.3245 133.522 23.3245C133.9 23.3245 134.131 23.5315 134.241 23.8603H135.726C135.483 22.7521 134.679 22.1189 133.547 22.1189C132.207 22.1189 131.27 23.0322 131.27 24.5057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.381 22.1189C139.709 22.1189 140.744 23.0322 140.744 24.5057C140.744 25.9792 139.696 26.8925 138.369 26.8925C137.03 26.8925 136.019 25.9792 136.019 24.5057C136.019 23.0322 137.054 22.1189 138.381 22.1189ZM138.369 25.6625C138.856 25.6625 139.319 25.285 139.319 24.5057C139.319 23.7141 138.868 23.3488 138.381 23.3488C137.882 23.3488 137.444 23.7141 137.444 24.5057C137.444 25.285 137.858 25.6625 138.369 25.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.578 22.9957C145.262 22.4356 144.714 22.1311 144.032 22.1311C143.435 22.1311 142.972 22.3869 142.704 22.7644V22.1798H141.316V26.8195H142.704V24.2987C142.704 23.6899 143.045 23.3611 143.581 23.3611C144.105 23.3611 144.446 23.6899 144.446 24.2987V26.8195H145.822V24.2987C145.822 23.6899 146.163 23.3611 146.698 23.3611C147.222 23.3611 147.563 23.6899 147.563 24.2987V26.8195H148.951V24.1161C148.951 22.8618 148.221 22.1311 147.1 22.1311C146.443 22.1311 145.87 22.5086 145.578 22.9957Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_168_919",
    x1: 13.8097,
    y1: 16.8729,
    x2: 19.1186,
    y2: 17.1339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B4BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#16EE96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16EE96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_168_919",
    x1: 6.78785,
    y1: 17.004,
    x2: 14.1088,
    y2: 17.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8165EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#8165EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B4BB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 28,
    fill: "white",
    transform: "translate(0 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_168_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 32.3034,
    fill: "white",
    transform: "translate(31 0.848297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.d6011112ae01ae5dd4b29ba7b113ab6c.svg";
export { ForwardRef as ReactComponent };